import { Component, EventEmitter, Output } from '@angular/core';
import { LoginService } from 'app/Services/login.service';
import { ClickEvent } from 'devextreme/ui/button';

@Component({
  selector: 'np-container-card',
  templateUrl: './container-card.component.html',
  styleUrl: './container-card.component.css'
})
export class ContainerCardComponent {
  @Output() onEditContainer = new EventEmitter<ClickEvent>();

  constructor(public loginService: LoginService) {}

  onEdit(event: ClickEvent) {
    this.onEditContainer.emit(event);
  }

}
